import React from "react";

// Authentic WhatsApp icon
export const WhatsAppIcon = ({ className = "h-5 w-5", color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    className={className}
    fill={color}
    aria-hidden="true"
  >
    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 01-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 01-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.846 2.722.846.345 0 2.422-.673 2.422-1.633 0-.387-.83-1.32-1.404-1.32zm-3.41 9.085c-1.605 0-3.16-.42-4.52-1.18l-.32-.19-3.36.875.92-3.275-.205-.32a8.948 8.948 0 01-1.396-4.794c0-4.973 4.05-9.024 9.024-9.024s9.024 4.05 9.024 9.024c0 4.974-4.05 9.024-9.024 9.024zm0-19.92c-6.013 0-10.896 4.883-10.896 10.896 0 1.91.512 3.79 1.482 5.453l-1.586 5.793 5.946-1.563a10.84 10.84 0 005.054 1.214c6.012 0 10.896-4.884 10.896-10.897 0-6.013-4.884-10.896-10.896-10.896z"></path>
  </svg>
);
